import { Modal } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useAxiosApi } from '@/hooks/useAxiosApi'
import FulfillmentOrderForm from '@/components/fulfillment_orders/create/FulfillmentOrderForm'

function getConsigneeFromServiceCase(serviceCase) {
    return {
        name: serviceCase.customer_address_name || '',
        company: serviceCase.customer_address_company || '',
        email: serviceCase.customer_email || '',
        phone: serviceCase.customer_phone || '',
        address1: serviceCase.customer_address_1 || '',
        address2: serviceCase.customer_address_2 || '',
        city: serviceCase.customer_address_city || '',
        zip: serviceCase.customer_address_postcode || '',
        country_code: serviceCase.customer_address_country || '',
    }
}

export default function CreateFulfillmentOrderModal({ serviceCase, opened, onClose, onSuccess }) {
    const { requestPost } = useAxiosApi()

    const handleSubmit = async (data) => {
        const response = await requestPost('/fulfillment-orders', {
            service_case_id: serviceCase.id,
            location_id: data.location_id,
            to_location_id: data.to_location_id,
            consignee: data.consignee,
            fulfill_at: data.fulfill_at,
            warranties_mode: data.warranties_mode,
            incoterm: data.incoterm,
            lines: data.lines.map((line) => ({
                variant_id: line.variant_id,
                component_id: line.component_id,
                quantity: line.total_quantity,
                unit_price: line.unit_price_initial,
            })),
        })

        if (response?.data?.id) {
            // Marquer l'échange comme effectué si c'est un swap
            if (serviceCase.type === 'swap_same' && !serviceCase.swapped_at) {
                await requestPost(`/service-cases/${serviceCase.id}/action`, {
                    action: 'toggle_flag',
                    data: { flag: 'swapped_at' },
                })
            }

            onClose()
            onSuccess?.()
            notifications.show({
                title: 'Bon de préparation créé',
                message: `BP${response.data.id} a été créé avec succès.`,
                color: 'green',
            })
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Créer un bon de préparation"
            size="xl"
            centered
        >
            <FulfillmentOrderForm
                initialConsignee={getConsigneeFromServiceCase(serviceCase)}
                initialLocationId={6}
                initialIncoterm="DDP"
                initialWarrantiesMode="associate"
                onSubmit={handleSubmit}
            />
        </Modal>
    )
}
